import { toDateTimeLocalValue } from '../../utils/appTimezone';

export function createEmptyRdvForm() {
  return {
    type_rendez_vous: 'MEDECIN',
    service: 'CONSULTATION_MEDECIN',
    priority: 'NORMALE',
    doctor_preference: 'SANS_PREFERENCE',
    doctor_id: '',
    patient_kind: 'SMIE',
    patient_id: '',
    date_rdv: '',
    heure_debut: '',
    date_fin: '',
    heure_fin: '',
    motif: '',
    note_interne: ''
  };
}

export function rdvPatientLabel(rdv) {
  if (!rdv) return '';
  return `${rdv.member_prenom || rdv.external_prenom || ''} ${rdv.member_nom || rdv.external_nom || ''}`.trim();
}

export function rdvToFormState(rdv) {
  if (!rdv) return createEmptyRdvForm();

  const startLocal = toDateTimeLocalValue(rdv.start_at);
  const [date_rdv = '', timeStartRaw = ''] = startLocal.split('T');
  const heure_debut = timeStartRaw.slice(0, 5);

  let date_fin = '';
  let heure_fin = '';
  if (rdv.end_at) {
    const endLocal = toDateTimeLocalValue(rdv.end_at);
    const [endDate = '', endTimeRaw = ''] = endLocal.split('T');
    date_fin = endDate;
    heure_fin = endTimeRaw.slice(0, 5);
  }

  return {
    type_rendez_vous: rdv.type_rendez_vous || 'MEDECIN',
    service: rdv.service || 'CONSULTATION_MEDECIN',
    priority: rdv.priority || 'NORMALE',
    doctor_preference: rdv.doctor_preference || 'SANS_PREFERENCE',
    doctor_id: rdv.doctor_id ? String(rdv.doctor_id) : '',
    patient_kind: rdv.member_id ? 'SMIE' : 'EXTERNE',
    patient_id: rdv.member_id
      ? String(rdv.member_id)
      : rdv.external_member_id
        ? String(rdv.external_member_id)
        : '',
    date_rdv,
    heure_debut,
    date_fin,
    heure_fin,
    motif: rdv.motif || '',
    note_interne: rdv.note_interne || ''
  };
}

export function buildRdvSubmitPayload(form, combineYmdAndTime) {
  const start = combineYmdAndTime(form.date_rdv, form.heure_debut);
  if (!start) {
    return { error: 'Date et heure de début requises' };
  }

  const end =
    form.date_fin && form.heure_fin ? combineYmdAndTime(form.date_fin, form.heure_fin) : null;
  if ((form.date_fin && !form.heure_fin) || (!form.date_fin && form.heure_fin)) {
    return { error: 'Date fin et heure fin doivent être renseignées ensemble' };
  }

  const requiresDoctor =
    (form.type_rendez_vous === 'MEDECIN' || form.type_rendez_vous === 'DENTISTE') &&
    form.doctor_preference === 'SPECIFIQUE';
  if (requiresDoctor && !form.doctor_id) {
    return { error: 'Sélectionnez un praticien' };
  }
  if (!form.patient_id) {
    return { error: 'Sélectionnez un patient' };
  }

  return {
    payload: {
      type_rendez_vous: form.type_rendez_vous,
      service: form.service,
      priority: form.priority,
      doctor_preference:
        form.type_rendez_vous === 'MEDECIN' || form.type_rendez_vous === 'DENTISTE'
          ? form.doctor_preference
          : 'SANS_PREFERENCE',
      ...(requiresDoctor ? { doctor_id: parseInt(form.doctor_id, 10) } : {}),
      ...(form.patient_kind === 'SMIE'
        ? { member_id: parseInt(form.patient_id, 10) }
        : { external_member_id: parseInt(form.patient_id, 10) }),
      start_at: start,
      ...(end ? { end_at: end } : {}),
      motif: form.motif.trim() || 'Consultation',
      note_interne: form.note_interne.trim() || null
    }
  };
}
